import * as React from "react";

import { keys, sum } from "lodash";
import QuestionnaireAccessTypeSelector, { accessTypeValueToAccessLevelState as accessTypeFunc } from "./QuestionnaireAccessTypeSelector";

import { useNavigate, useParams } from "react-router-dom";
import AccessRuleRenderer from "../components/AccessRuleRenderer";
import { GetQuestionnaire, Questionnaire, UpdateQuestionnaireAccessPolicy } from "../utils/ServiceManagerAPI";
import "../main.css";

const QuestionnaireAccessPoliciesUpdate = () => {
    const navigate = useNavigate();
    const { rule, questionnaireId } = useParams();

    const [accessLevels, setAccessLevels] = React.useState({} as any);
    const [policyTarget, setPolicyTarget] = React.useState(rule);
    const [policyType, setPolicyType] = React.useState({ value: "membership", label: "Membership" });
    const [questionnaire, setQuestionnaire] = React.useState({} as Questionnaire);

    React.useEffect(() => {
        GetQuestionnaire(questionnaireId).then((res) => {
            setQuestionnaire(res.questionnaire);
        });
    }, [questionnaireId]);

    React.useEffect(() => {
        let policy = questionnaire?.accessPolicies?.filter((a) => a.rule == rule)[0];
        setAccessLevels(accessTypeFunc(policy?.accessType));
    }, [questionnaire]);

    const updateAccessPolicy = () => {
        UpdateQuestionnaireAccessPolicy({
            accessType: sum(keys(accessLevels).map((k) => +k)),
            questionnaireID: questionnaire.id,
            rule: policyTarget,
        }).then(() => {
            navigate(-1);
        });
    };

    return (
        <div className="w-full max-w-4xl">
            <h3 className="text-xl font-bold text-gray-900 dark:text-gray-100 mb-4">Access Policies</h3>
            <div className="flex flex-col gap-1 mb-4">
                <label className="text-sm text-gray-700 dark:text-gray-300">Policy Type</label>
                <select
                    value={policyType.value}
                    disabled
                    onChange={(e) => {
                        const selected = [
                            { value: "membership", label: "Membership" },
                            { value: "group", label: "Group" },
                            { value: "user", label: "User" },
                        ].find(p => p.value == e.target.value);
                        setPolicyType(selected || { value: "membership", label: "Membership" });
                    }}
                    className="border border-gray-300 dark:border-gray-600 rounded px-3 py-2 w-full text-gray-900 dark:text-gray-100 bg-white dark:bg-gray-800 disabled:opacity-50"
                >
                    <option value="membership">Membership</option>
                    <option value="group">Group</option>
                    <option value="user">User</option>
                </select>
            </div>

            <div className="flex flex-col gap-1 mb-4">
                <label className="text-sm text-gray-700 dark:text-gray-300">Policy Target</label>
                <div className="p-2">
                    <AccessRuleRenderer rule={policyTarget || ""}></AccessRuleRenderer>
                </div>
            </div>
            <div className="flex flex-col gap-1 mb-4">
                <span className="text-gray-900 dark:text-gray-100">Questionnaire Type Access</span>
                <QuestionnaireAccessTypeSelector handleChange={(a) => setAccessLevels(a)} value={accessLevels}></QuestionnaireAccessTypeSelector>
            </div>
            <button 
                className="px-4 py-2 rounded bg-brand text-white hover:bg-brand-dark transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={updateAccessPolicy}
                disabled={!policyTarget}
            >
                Update
            </button>
        </div>
    );
};
export default QuestionnaireAccessPoliciesUpdate;
